export const OAUTH = "OAUTH";
export const POPULATE_PROFILE = "POPULATE_PROFILE";
